import React from 'react';
import { FormattedMessage } from 'react-intl';
import commonMessages from 'common/messages/messages';

export enum PoliciesPermissionSetItems {
  // Club level
  // Financial group
  SET_CLIENT_FEE_SCHEDULE = 'SET_CLIENT_FEE_SCHEDULE',
  // Point of sale group
  GIVE_DISCOUNT = 'GIVE_DISCOUNT', // Implemented
  VOID_INVOICE = 'VOID_INVOICE', // Implemented
  OPEN_REGISTER = 'OPEN_REGISTER', // Implemented
  CLOSE_REGISTER = 'CLOSE_REGISTER', // Implemented
  MODIFY_SALESPERSON = 'MODIFY_SALESPERSON',
  SERVICE_PARAMETER_OVERRIDE = 'SERVICE_PARAMETER_OVERRIDE', // Implemented
  // Sales management
  SALES_VIEW_LEADS = 'SALES_VIEW_LEADS',
  SALES_EDIT_LEADS = 'SALES_EDIT_LEADS',
  COMMISSION_RULE_VIEW = 'COMMISSION_RULE_VIEW', // Implemented
  COMMISSION_RULE_CREATE = 'COMMISSION_RULE_CREATE', // Implemented
  COMMISSION_RULE_EDIT = 'COMMISSION_RULE_EDIT', // Implemented
  COMMISSION_RULE_DELETE = 'COMMISSION_RULE_DELETE', // Implemented
  DAYSHEET_VIEW = 'DAYSHEET_VIEW', // Implemented
  // Collections group
  SEND_A_LETTER = 'SEND_A_LETTER',
  // corporate or club level
  // scheduling
  BOOKING_EVENTS_VIEW = 'BOOKING_EVENTS_VIEW', // Implemented
  BOOKING_EVENTS_VIEW_ONE = 'BOOKING_EVENTS_VIEW_ONE', // Implemented
  BOOKING_EVENTS_CREATE = 'BOOKING_EVENTS_CREATE', // Implemented
  BOOKING_EVENTS_EDIT = 'BOOKING_EVENTS_EDIT', // Implemented
  BOOKING_EVENTS_CANCEL = 'BOOKING_EVENTS_CANCEL', // Implemented
  BOOKING_EVENTS_DELETE = 'BOOKING_EVENTS_DELETE', // Implemented
  BOOKING_EVENTS_DUPLICATE = 'BOOKING_EVENTS_DUPLICATE', // Implemented
  BOOKING_EVENTS_REMIND_PARTICIPANTS = 'BOOKING_EVENTS_REMIND_PARTICIPANTS', // Implemented
  BOOKING_EVENTS_NOT_SELF_EDIT = 'BOOKING_EVENTS_NOT_SELF_EDIT',
  BOOKING_RESOURCES_VIEW = 'BOOKING_RESOURCES_VIEW', // Implemented
  BOOKING_RESOURCES_CREATE = 'BOOKING_RESOURCES_CREATE', // Implemented
  BOOKING_RESOURCES_EDIT = 'BOOKING_RESOURCES_EDIT', // Implemented
  BOOKING_RESOURCES_CHANGE_STATUS = 'BOOKING_RESOURCES_CHANGE_STATUS', // Implemented
  BOOKING_APPOINTMENTS_VIEW = 'BOOKING_APPOINTMENTS_VIEW', // Implemented
  // crm
  CRM_TASK_VIEW = 'CRM_TASK_VIEW', // Implemented
  CRM_TASK_VIEW_OWN = 'CRM_TASK_VIEW_OWN', // Implemented
  CRM_TASK_EDIT_STATUS = 'CRM_TASK_EDIT_STATUS', // Implemented
  CRM_TASK_EDIT_SALESPERSON = 'CRM_TASK_EDIT_SALESPERSON', // Implemented
  CRM_LEAD_VIEW = 'CRM_LEAD_VIEW', // Implemented
  CRM_LEAD_VIEW_OWN = 'CRM_LEAD_VIEW_OWN', // Implemented
  CRM_LEAD_CREATE = 'CRM_LEAD_CREATE', // Implemented
  CRM_LEAD_EDIT = 'CRM_LEAD_EDIT', // Implemented
  CRM_LEAD_EDIT_STATUS = 'CRM_LEAD_EDIT_STATUS', // Implemented
  CRM_LEAD_EDIT_SALESPERSON = 'CRM_LEAD_EDIT_SALESPERSON', // Implemented
  CRM_LEAD_EDIT_MEMBERSHIP = 'CRM_LEAD_EDIT_MEMBERSHIP', // Implemented
  CRM_SCRIPT_VIEW = 'CRM_SCRIPT_VIEW', // Implemented
  CRM_SCRIPT_CREATE = 'CRM_SCRIPT_CREATE', // Implemented
  CRM_SCRIPT_EDIT = 'CRM_SCRIPT_EDIT', // Implemented
  CRM_SCRIPT_CHANGE_STATUS = 'CRM_SCRIPT_CHANGE_STATUS', // Implemented
  CRM_CAMPAIGN_VIEW = 'CRM_CAMPAIGN_VIEW', // Implemented
  CRM_CAMPAIGN_CREATE = 'CRM_CAMPAIGN_CREATE', // Implemented
  CRM_CAMPAIGN_EDIT = 'CRM_CAMPAIGN_EDIT', // Implemented
  CRM_CAMPAIGN_CHANGE_STATUS = 'CRM_CAMPAIGN_CHANGE_STATUS',
  CRM_SMS_TEMPLATE_VIEW = 'CRM_SMS_TEMPLATE_VIEW', // Implemented
  CRM_SMS_TEMPLATE_CREATE = 'CRM_SMS_TEMPLATE_CREATE', // Implemented
  CRM_SMS_TEMPLATE_EDIT = 'CRM_SMS_TEMPLATE_EDIT', // Implemented
  CRM_SMS_TEMPLATE_CHANGE_STATUS = 'CRM_SMS_TEMPLATE_CHANGE_STATUS', // Implemented
  CRM_EMAIL_TEMPLATE_VIEW = 'CRM_EMAIL_TEMPLATE_VIEW', // Implemented
  CRM_EMAIL_TEMPLATE_CREATE = 'CRM_EMAIL_TEMPLATE_CREATE', // Implemented
  CRM_EMAIL_TEMPLATE_EDIT = 'CRM_EMAIL_TEMPLATE_EDIT', // Implemented
  CRM_EMAIL_TEMPLATE_CHANGE_STATUS = 'CRM_EMAIL_TEMPLATE_CHANGE_STATUS', // Implemented
  // pt crm
  PT_CRM_TASK_VIEW = 'PT_CRM_TASK_VIEW', // Implemented
  PT_CRM_TASK_VIEW_OWN = 'PT_CRM_TASK_VIEW_OWN', // Implemented
  PT_CRM_TASK_EDIT_STATUS = 'PT_CRM_TASK_EDIT_STATUS', // Implemented
  PT_CRM_TASK_EDIT_SALESPERSON = 'PT_CRM_TASK_EDIT_SALESPERSON', // Implemented
  PT_CRM_LEAD_VIEW = 'PT_CRM_LEAD_VIEW', // Implemented
  PT_CRM_LEAD_VIEW_OWN = 'PT_CRM_LEAD_VIEW_OWN', // Implemented
  PT_CRM_LEAD_CREATE = 'PT_CRM_LEAD_CREATE', // Implemented
  PT_CRM_LEAD_EDIT = 'PT_CRM_LEAD_EDIT', // Implemented
  PT_CRM_LEAD_EDIT_STATUS = 'PT_CRM_LEAD_EDIT_STATUS', // Implemented
  PT_CRM_LEAD_EDIT_SALESPERSON = 'PT_CRM_LEAD_EDIT_SALESPERSON', // Implemented
  PT_CRM_LEAD_EDIT_MEMBERSHIP = 'PT_CRM_LEAD_EDIT_MEMBERSHIP', // Implemented
  PT_CRM_SCRIPT_VIEW = 'PT_CRM_SCRIPT_VIEW', // Implemented
  PT_CRM_SCRIPT_CREATE = 'PT_CRM_SCRIPT_CREATE', // Implemented
  PT_CRM_SCRIPT_EDIT = 'PT_CRM_SCRIPT_EDIT', // Implemented
  PT_CRM_SCRIPT_CHANGE_STATUS = 'PT_CRM_SCRIPT_CHANGE_STATUS', // Implemented
  PT_CRM_CAMPAIGN_VIEW = 'PT_CRM_CAMPAIGN_VIEW', // Implemented
  PT_CRM_CAMPAIGN_CREATE = 'PT_CRM_CAMPAIGN_CREATE', // Implemented
  PT_CRM_CAMPAIGN_EDIT = 'PT_CRM_CAMPAIGN_EDIT', // Implemented
  PT_CRM_CAMPAIGN_CHANGE_STATUS = 'PT_CRM_CAMPAIGN_CHANGE_STATUS',
  PT_CRM_SMS_TEMPLATE_VIEW = 'PT_CRM_SMS_TEMPLATE_VIEW', // Implemented
  PT_CRM_SMS_TEMPLATE_CREATE = 'PT_CRM_SMS_TEMPLATE_CREATE', // Implemented
  PT_CRM_SMS_TEMPLATE_EDIT = 'PT_CRM_SMS_TEMPLATE_EDIT', // Implemented
  PT_CRM_SMS_TEMPLATE_CHANGE_STATUS = 'PT_CRM_SMS_TEMPLATE_CHANGE_STATUS', // Implemented
  PT_CRM_EMAIL_TEMPLATE_VIEW = 'PT_CRM_EMAIL_TEMPLATE_VIEW', // Implemented
  PT_CRM_EMAIL_TEMPLATE_CREATE = 'PT_CRM_EMAIL_TEMPLATE_CREATE', // Implemented
  PT_CRM_EMAIL_TEMPLATE_EDIT = 'PT_CRM_EMAIL_TEMPLATE_EDIT', // Implemented
  PT_CRM_EMAIL_TEMPLATE_CHANGE_STATUS = 'PT_CRM_EMAIL_TEMPLATE_CHANGE_STATUS', // Implemented
  // member management
  MEMBER_VIEW = 'MEMBER_VIEW', // Implemented
  MEMBER_VIEW_ONE = 'MEMBER_VIEW_ONE', // Implemented
  MEMBER_CREATE = 'MEMBER_CREATE', // Implemented
  MEMBER_EDIT = 'MEMBER_EDIT', // Implemented
  MEMBER_REWARD_POINT_EDIT = 'MEMBER_REWARD_POINT_EDIT', // Implemented
  MEMBER_SESSION_REDEEM = 'MEMBER_SESSION_REDEEM', // Implemented
  MEMBER_SESSION_UNREDEEM = 'MEMBER_SESSION_UNREDEEM',
  MEMBER_SERVICE_FREEZE = 'MEMBER_SERVICE_FREEZE', // Implemented
  MEMBER_WAIVE_FEE = 'MEMBER_WAIVE_FEE', // Implemented
  MEMBER_VIEW_DOCUMENTS = 'MEMBER_VIEW_DOCUMENTS', // Implemented
  MEMBER_UPLOAD_DOCUMENTS = 'MEMBER_UPLOAD_DOCUMENTS', // Implemented
  MEMBER_ALERT_MANAGE_SETTINGS = 'MEMBER_ALERT_MANAGE_SETTINGS', // Implemented
  MEMBER_ALERT_RESOLVE = 'MEMBER_ALERT_RESOLVE', // Implemented
  // employee management
  EMPLOYEE_VIEW = 'EMPLOYEE_VIEW', // Implemented
  EMPLOYEE_CREATE = 'EMPLOYEE_CREATE', // Implemented
  EMPLOYEE_EDIT = 'EMPLOYEE_EDIT', // Implemented
  EMPLOYEE_CHANGE_STATUS = 'EMPLOYEE_CHANGE_STATUS', // Implemented
  EMPLOYEE_UPDATE_PERMISSIONS = 'EMPLOYEE_UPDATE_PERMISSIONS', // Implemented
  EMPLOYEE_TAKE_PHOTO = 'EMPLOYEE_TAKE_PHOTO', // Implemented
  EMPLOYEE_VIEW_DOCUMENTS = 'EMPLOYEE_VIEW_DOCUMENTS', // Implemented
  EMPLOYEE_UPLOAD_DOCUMENTS = 'EMPLOYEE_UPLOAD_DOCUMENTS', // Implemented
  // time clock
  TIME_CLOCK_VIEW = 'TIME_CLOCK_VIEW', // Implemented
  TIME_CLOCK_VIEW_OWN = 'TIME_CLOCK_VIEW_OWN',
  TIME_CLOCK_DELETE = 'TIME_CLOCK_DELETE', // Implemented
  TIME_CLOCK_IN = 'TIME_CLOCK_IN', // Implemented
  TIME_CLOCK_OUT = 'TIME_CLOCK_OUT', // Implemented
  TIME_CLOCK_PAYROLL_REPORT_VIEW = 'TIME_CLOCK_PAYROLL_REPORT_VIEW', // Implemented
  TIME_CLOCK_PAYROLL_REPORT_VIEW_OWN = 'TIME_CLOCK_PAYROLL_REPORT_VIEW_OWN', // Implemented
  TIME_CLOCK_PAYROLL_REPORT_DELETE = 'TIME_CLOCK_PAYROLL_REPORT_DELETE', // Implemented
  TIME_CLOCK_PAYROLL_REPORT_EXPORT = 'TIME_CLOCK_PAYROLL_REPORT_EXPORT', // Implemented
  // reporting
  REPORTS_VIEW = 'REPORTS_VIEW',
  REPORTS_EXPORT = 'REPORTS_EXPORT',
  OVERVIEW_REPORT_VIEW = 'OVERVIEW_REPORT_VIEW', // Implemented
  OVERVIEW_REPORT_EXPORT = 'OVERVIEW_REPORT_EXPORT', // Implemented
  EXTERNAL_COLLECTIONS_REPORT_VIEW = 'EXTERNAL_COLLECTIONS_REPORT_VIEW', // Implemented
  EXTERNAL_COLLECTIONS_REPORT_EXPORT = 'EXTERNAL_COLLECTIONS_REPORT_EXPORT', // Implemented
  SALES_REPORT_VIEW = 'SALES_REPORT_VIEW', // Implemented
  SALES_REPORT_EDIT = 'SALES_REPORT_EDIT',
  SALES_REPORT_EXPORT = 'SALES_REPORT_EXPORT', // Implemented
  INVOICE_REPORT_VIEW = 'INVOICE_REPORT_VIEW', // Implemented
  INVOICE_REPORT_DETAILED_VIEW = 'INVOICE_REPORT_DETAILED_VIEW', // Implemented
  INVOICE_REPORT_EXPORT = 'INVOICE_REPORT_EXPORT', // Implemented
  INVOICE_REPORT_VIEW_SNAPSHOTS = 'INVOICE_REPORT_VIEW_SNAPSHOTS', // Implemented
  INVOICE_REPORT_MAKE_SNAPSHOT = 'INVOICE_REPORT_MAKE_SNAPSHOT', // Implemented
  INVOICE_REPORT_ASSIGN_MEMBER = 'INVOICE_REPORT_ASSIGN_MEMBER', // Implemented
  INVOICE_REPORT_REFUND = 'INVOICE_REPORT_REFUND', // Implemented
  INVOICE_REPORT_VOID = 'INVOICE_REPORT_VOID', // Implemented
  Z_REPORT_VIEW = 'Z_REPORT_VIEW', // Implemented
  Z_REPORT_DETAILED_VIEW = 'Z_REPORT_DETAILED_VIEW', // Implemented
  Z_REPORT_EXPORT = 'Z_REPORT_EXPORT', // Implemented
  SCHEDULED_BILLINGS_REPORT_VIEW = 'SCHEDULED_BILLINGS_REPORT_VIEW', // Implemented
  SCHEDULED_BILLINGS_REPORT_EXPORT = 'SCHEDULED_BILLINGS_REPORT_EXPORT', // Implemented
  OVER_TIME_REPORT_VIEW = 'OVER_TIME_REPORT_VIEW', // Implemented
  OVER_TIME_REPORT_EXPORT = 'OVER_TIME_REPORT_EXPORT', // Implemented
  REGISTER_STATUS_REPORT_VIEW = 'REGISTER_STATUS_REPORT_VIEW', // Implemented
  REGISTER_STATUS_REPORT_EXPORT = 'REGISTER_STATUS_REPORT_EXPORT', // Implemented
  REGISTER_STATUS_REPORT_CLOSE = 'REGISTER_STATUS_REPORT_CLOSE', // Implemented
  TRANSACTION_REPORT_VIEW = 'TRANSACTION_REPORT_VIEW', // Implemented
  TRANSACTION_REPORT_EXPORT = 'TRANSACTION_REPORT_EXPORT', // Implemented
  REDEMPTION_REPORT_VIEW = 'REDEMPTION_REPORT_VIEW', // Implemented
  REDEMPTION_REPORT_EXPORT = 'REDEMPTION_REPORT_EXPORT', // Implemented
  REDEMPTION_REPORT_UNREDEEM = 'REDEMPTION_REPORT_UNREDEEM', // Implemented
  CHARGE_PAYMENT_ANALYSIS_REPORT_VIEW = 'CHARGE_PAYMENT_ANALYSIS_REPORT_VIEW',
  CHARGE_PAYMENT_ANALYSIS_REPORT_EXPORT = 'CHARGE_PAYMENT_ANALYSIS_REPORT_EXPORT',
  FINANCIAL_SUMMARY_REPORT_VIEW = 'FINANCIAL_SUMMARY_REPORT_VIEW',
  FINANCIAL_SUMMARY_REPORT_EXPORT = 'FINANCIAL_SUMMARY_REPORT_EXPORT',
  DEPOSIT_STATEMENT_REPORT_VIEW = 'DEPOSIT_STATEMENT_REPORT_VIEW',
  DEPOSIT_STATEMENT_REPORT_EXPORT = 'DEPOSIT_STATEMENT_REPORT_EXPORT',
  DASHBOARD_REPORT_VIEW = 'DASHBOARD_REPORT_VIEW', // Implemented
  DASHBOARD_REPORT_EXPORT = 'DASHBOARD_REPORT_EXPORT', // Implemented
  CAMPAIGN_REPORT_VIEW = 'CAMPAIGN_REPORT_VIEW', // Implemented
  CAMPAIGN_REPORT_DETAILED_VIEW = 'CAMPAIGN_REPORT_DETAILED_VIEW', // Implemented
  CAMPAIGN_REPORT_EXPORT = 'CAMPAIGN_REPORT_EXPORT', // Implemented
  APPOINTMENT_REPORT_VIEW = 'APPOINTMENT_REPORT_VIEW', // Implemented
  APPOINTMENT_REPORT_DETAILED_VIEW = 'APPOINTMENT_REPORT_DETAILED_VIEW', // Implemented
  APPOINTMENT_REPORT_EXPORT = 'APPOINTMENT_REPORT_EXPORT', // Implemented
  CHECK_IN_HISTORY_REPORT_VIEW = 'CHECK_IN_HISTORY_REPORT_VIEW', // Implemented
  CHECK_IN_HISTORY_REPORT_EXPORT = 'CHECK_IN_HISTORY_REPORT_EXPORT', // Implemented
  KID_ZONE_CHECK_IN_HISTORY_REPORT_VIEW = 'KID_ZONE_CHECK_IN_HISTORY_REPORT_VIEW', // Implemented
  KID_ZONE_CHECK_IN_HISTORY_REPORT_EXPORT = 'KID_ZONE_CHECK_IN_HISTORY_REPORT_EXPORT', // Implemented
  // corporate level
  // Service management
  CORPORATE_SU = 'CORPORATE_SU',
  SERVICE_VIEW = 'SERVICE_VIEW', // Implemented
  SERVICE_CREATE = 'SERVICE_CREATE', // Implemented
  SERVICE_EDIT = 'SERVICE_EDIT', // Implemented
  SERVICE_CHANGE_STATUS = 'SERVICE_CHANGE_STATUS', // Implemented
  FEE_VIEW = 'FEE_VIEW', // Implemented
  FEE_CREATE = 'FEE_CREATE', // Implemented
  FEE_EDIT = 'FEE_EDIT', // Implemented
  FEE_CHANGE_STATUS = 'FEE_CHANGE_STATUS', // Implemented
  SERVICE_BUNDLE_VIEW = 'SERVICE_BUNDLE_VIEW', // Implemented
  SERVICE_BUNDLE_CREATE = 'SERVICE_BUNDLE_CREATE', // Implemented
  SERVICE_BUNDLE_EDIT = 'SERVICE_BUNDLE_EDIT', // Implemented
  SERVICE_BUNDLE_CHANGE_STATUS = 'SERVICE_BUNDLE_CHANGE_STATUS', // Implemented
  SERVICE_BUNDLE_DUPLICATE = 'SERVICE_BUNDLE_DUPLICATE', // Implemented
  CONTRACT_VIEW = 'CONTRACT_VIEW', // Implemented
  CONTRACT_CREATE = 'CONTRACT_CREATE', // Implemented
  CONTRACT_EDIT = 'CONTRACT_EDIT', // Implemented
  CONTRACT_CHANGE_STATUS = 'CONTRACT_CHANGE_STATUS', // Implemented
  WAIVER_VIEW = 'WAIVER_VIEW', // Implemented
  WAIVER_CREATE = 'WAIVER_CREATE', // Implemented
  WAIVER_EDIT = 'WAIVER_EDIT', // Implemented
  WAIVER_CHANGE_STATUS = 'WAIVER_CHANGE_STATUS', // Implemented
  // POS content
  POP_OPEN_CASH_DRAWER = 'POP_OPEN_CASH_DRAWER', // Implemented
  RECEIPT_TEMPLATES_VIEW = 'RECEIPT_TEMPLATES_VIEW', // Implemented
  RECEIPT_TEMPLATES_VIEW_ONE = 'RECEIPT_TEMPLATES_VIEW_ONE', // Implemented
  RECEIPT_TEMPLATES_CREATE = 'RECEIPT_TEMPLATES_CREATE', // Implemented
  RECEIPT_TEMPLATES_EDIT = 'RECEIPT_TEMPLATES_EDIT', // Implemented
  RECEIPT_TEMPLATES_CHANGE_STATUS = 'RECEIPT_TEMPLATES_CHANGE_STATUS', // Implemented
  RECEIPT_TEMPLATES_PRINT = 'RECEIPT_TEMPLATES_PRINT',
  TAX_RATE_VIEW = 'TAX_RATE_VIEW', // Implemented
  TAX_RATE_CREATE = 'TAX_RATE_CREATE', // Implemented
  TAX_RATE_EDIT = 'TAX_RATE_EDIT', // Implemented
  TAX_RATE_CHANGE_STATUS = 'TAX_RATE_CHANGE_STATUS', // Implemented
  REVENUE_CODE_VIEW = 'REVENUE_CODE_VIEW', // Implemented
  REVENUE_CODE_CREATE = 'REVENUE_CODE_CREATE', // Implemented
  REVENUE_CODE_EDIT = 'REVENUE_CODE_EDIT', // Implemented
  REVENUE_CODE_CHANGE_STATUS = 'REVENUE_CODE_CHANGE_STATUS', // Implemented
  VENDOR_VIEW = 'VENDOR_VIEW', // Implemented
  VENDOR_VIEW_ONE = 'VENDOR_VIEW_ONE', // Implemented
  VENDOR_CREATE = 'VENDOR_CREATE', // Implemented
  VENDOR_EDIT = 'VENDOR_EDIT', // Implemented
  VENDOR_CHANGE_STATUS = 'VENDOR_CHANGE_STATUS', // Implemented
  INVENTORY_VIEW = 'INVENTORY_VIEW', // Implemented
  INVENTORY_VIEW_ONE = 'INVENTORY_VIEW_ONE', // Implemented
  INVENTORY_CREATE = 'INVENTORY_CREATE', // Implemented
  INVENTORY_EDIT = 'INVENTORY_EDIT', // Implemented
  INVENTORY_CHANGE_STATUS = 'INVENTORY_CHANGE_STATUS', // Implemented
  REGISTER_VIEW = 'REGISTER_VIEW', // Implemented
  REGISTER_VIEW_ONE = 'REGISTER_VIEW_ONE', // Implemented
  REGISTER_CREATE = 'REGISTER_CREATE', // Implemented
  REGISTER_EDIT = 'REGISTER_EDIT', // Implemented
  REGISTER_CHANGE_STATUS = 'REGISTER_CHANGE_STATUS', // Implemented
  DEFAULT_PAYMENT_METHOD_VIEW = 'DEFAULT_PAYMENT_METHOD_VIEW', // Implemented
  DEFAULT_PAYMENT_METHOD_EDIT = 'DEFAULT_PAYMENT_METHOD_EDIT', // Implemented
  DEFAULT_PAYMENT_METHOD_CHANGE_STATUS = 'DEFAULT_PAYMENT_METHOD_CHANGE_STATUS', // Implemented
  CUSTOM_PAYMENT_METHOD_VIEW = 'CUSTOM_PAYMENT_METHOD_VIEW', // Implemented
  CUSTOM_PAYMENT_METHOD_VIEW_ONE = 'CUSTOM_PAYMENT_METHOD_VIEW_ONE', // Implemented
  CUSTOM_PAYMENT_METHOD_CREATE = 'CUSTOM_PAYMENT_METHOD_CREATE', // Implemented
  CUSTOM_PAYMENT_METHOD_EDIT = 'CUSTOM_PAYMENT_METHOD_EDIT', // Implemented
  CUSTOM_PAYMENT_METHOD_CHANGE_STATUS = 'CUSTOM_PAYMENT_METHOD_CHANGE_STATUS', // Implemented
  // Dictionaries
  DICTIONARIES_VIEW = 'DICTIONARIES_VIEW',
  DICTIONARIES_CREATE = 'DICTIONARIES_CREATE',
  DICTIONARIES_EDIT = 'DICTIONARIES_EDIT',
  DICTIONARIES_CHANGE_STATUS = 'DICTIONARIES_CHANGE_STATUS',
  CAME_FROM_INDICATION_VIEW = 'CAME_FROM_INDICATION_VIEW', // Implemented
  CAME_FROM_INDICATION_CREATE = 'CAME_FROM_INDICATION_CREATE', // Implemented
  CAME_FROM_INDICATION_EDIT = 'CAME_FROM_INDICATION_EDIT', // Implemented
  CAME_FROM_INDICATION_CHANGE_STATUS = 'CAME_FROM_INDICATION_CHANGE_STATUS', // Implemented
  ADDITIONAL_GUEST_FIELD_VIEW = 'ADDITIONAL_GUEST_FIELD_VIEW', // Implemented
  ADDITIONAL_GUEST_FIELD_CREATE = 'ADDITIONAL_GUEST_FIELD_CREATE', // Implemented
  ADDITIONAL_GUEST_FIELD_EDIT = 'ADDITIONAL_GUEST_FIELD_EDIT', // Implemented
  ADDITIONAL_GUEST_FIELD_CHANGE_STATUS = 'ADDITIONAL_GUEST_FIELD_CHANGE_STATUS', // Implemented
  ALERT_SOUND_VIEW = 'ALERT_SOUND_VIEW', // Implemented
  ALERT_SOUND_EDIT = 'ALERT_SOUND_EDIT', // Implemented
  NOTE_CODE_VIEW = 'NOTE_CODE_VIEW', // Implemented
  NOTE_CODE_CREATE = 'NOTE_CODE_CREATE', // Implemented
  NOTE_CODE_EDIT = 'NOTE_CODE_EDIT', // Implemented
  NOTE_CODE_CHANGE_STATUS = 'NOTE_CODE_CHANGE_STATUS', // Implemented
  FALLTHROUGH_REASON_VIEW = 'FALLTHROUGH_REASON_VIEW', // Implemented
  FALLTHROUGH_REASON_CREATE = 'FALLTHROUGH_REASON_CREATE', // Implemented
  FALLTHROUGH_REASON_EDIT = 'FALLTHROUGH_REASON_EDIT', // Implemented
  FALLTHROUGH_REASON_CHANGE_STATUS = 'FALLTHROUGH_REASON_CHANGE_STATUS', // Implemented
  DEPARTMENT_VIEW = 'DEPARTMENT_VIEW', // Implemented
  DEPARTMENT_CREATE = 'DEPARTMENT_CREATE', // Implemented
  DEPARTMENT_EDIT = 'DEPARTMENT_EDIT', // Implemented
  DEPARTMENT_CHANGE_STATUS = 'DEPARTMENT_CHANGE_STATUS', // Implemented
  CLIENT_GROUP_VIEW = 'CLIENT_GROUP_VIEW', // Implemented
  CLIENT_GROUP_CREATE = 'CLIENT_GROUP_CREATE', // Implemented
  CLIENT_GROUP_EDIT = 'CLIENT_GROUP_EDIT', // Implemented
  CLIENT_GROUP_CHANGE_STATUS = 'CLIENT_GROUP_CHANGE_STATUS', // Implemented
  INSURANCE_COMPANY_VIEW = 'INSURANCE_COMPANY_VIEW', // Implemented
  INSURANCE_COMPANY_CREATE = 'INSURANCE_COMPANY_CREATE', // Implemented
  INSURANCE_COMPANY_EDIT = 'INSURANCE_COMPANY_EDIT', // Implemented
  INSURANCE_COMPANY_CHANGE_STATUS = 'INSURANCE_COMPANY_CHANGE_STATUS', // Implemented
  ACCESS_HOUR_VIEW = 'ACCESS_HOUR_VIEW', // Implemented
  ACCESS_HOUR_CREATE = 'ACCESS_HOUR_CREATE', // Implemented
  ACCESS_HOUR_EDIT = 'ACCESS_HOUR_EDIT', // Implemented
  ACCESS_HOUR_CHANGE_STATUS = 'ACCESS_HOUR_CHANGE_STATUS', // Implemented
  EVENT_TAG_VIEW = 'EVENT_TAG_VIEW', // Implemented
  EVENT_TAG_CREATE = 'EVENT_TAG_CREATE', // Implemented
  EVENT_TAG_EDIT = 'EVENT_TAG_EDIT', // Implemented
  EVENT_TAG_CHANGE_STATUS = 'EVENT_TAG_CHANGE_STATUS', // Implemented
  RESOURCE_TAG_VIEW = 'RESOURCE_TAG_VIEW', // Implemented
  RESOURCE_TAG_CREATE = 'RESOURCE_TAG_CREATE', // Implemented
  RESOURCE_TAG_EDIT = 'RESOURCE_TAG_EDIT', // Implemented
  RESOURCE_TAG_CHANGE_STATUS = 'RESOURCE_TAG_CHANGE_STATUS', // Implemented
  NOTIFICATION_VIEW = 'NOTIFICATION_VIEW', // Implemented
  NOTIFICATION_EDIT = 'NOTIFICATION_EDIT', // Implemented
  HELP_INFORMATION_VIEW = 'HELP_INFORMATION_VIEW', // Implemented
  HELP_INFORMATION_CREATE = 'HELP_INFORMATION_CREATE', // Implemented
  HELP_INFORMATION_EDIT = 'HELP_INFORMATION_EDIT', // Implemented
  HELP_INFORMATION_CHANGE_STATUS = 'HELP_INFORMATION_CHANGE_STATUS', // Implemented
  END_REASON_VIEW = 'END_REASON_VIEW', // Implemented
  END_REASON_CREATE = 'END_REASON_CREATE', // Implemented
  END_REASON_EDIT = 'END_REASON_EDIT', // Implemented
  END_REASON_CHANGE_STATUS = 'END_REASON_CHANGE_STATUS', // Implemented
  // Permissions
  SECURITY_ROLE_VIEW = 'SECURITY_ROLE_VIEW', // Implemented
  SECURITY_ROLE_CREATE = 'SECURITY_ROLE_CREATE', // Implemented
  SECURITY_ROLE_EDIT = 'SECURITY_ROLE_EDIT', // Implemented
  SECURITY_ROLE_CHANGE_STATUS = 'SECURITY_ROLE_CHANGE_STATUS', // Implemented
  SECURITY_POLICY_VIEW = 'SECURITY_POLICY_VIEW', // Implemented
  SECURITY_POLICY_CREATE = 'SECURITY_POLICY_CREATE', // Implemented
  SECURITY_POLICY_EDIT = 'SECURITY_POLICY_EDIT', // Implemented
  SECURITY_POLICY_CHANGE_STATUS = 'SECURITY_POLICY_CHANGE_STATUS', // Implemented
  // Client management
  CLIENT_LIST_VIEW = 'CLIENT_LIST_VIEW', // Implemented
  CLIENT_CREATE = 'CLIENT_CREATE', // Implemented
  CLIENT_CHANGE_STATUS = 'CLIENT_CHANGE_STATUS', // Implemented
  CLIENT_GENERAL_INFO_VIEW = 'CLIENT_GENERAL_INFO_VIEW', // Implemented
  CLIENT_GENERAL_INFO_EDIT = 'CLIENT_GENERAL_INFO_EDIT', // Implemented
  CLIENT_BANK_INFO_VIEW = 'CLIENT_BANK_INFO_VIEW', // Implemented
  CLIENT_BANK_INFO_EDIT = 'CLIENT_BANK_INFO_EDIT', // Implemented
  CLIENT_BILLING_INFO_VIEW = 'CLIENT_BILLING_INFO_VIEW', // Implemented
  CLIENT_BILLING_INFO_EDIT = 'CLIENT_BILLING_INFO_EDIT', // Implemented
  CLIENT_FEE_RATES_VIEW = 'CLIENT_FEE_RATES_VIEW', // Implemented
  CLIENT_FEE_RATES_EDIT = 'CLIENT_FEE_RATES_EDIT', // Implemented
  CLIENT_PROCESSOR_CONFIGURATION_VIEW = 'CLIENT_PROCESSOR_CONFIGURATION_VIEW', // Implemented
  CLIENT_PROCESSOR_CONFIGURATION_EDIT = 'CLIENT_PROCESSOR_CONFIGURATION_EDIT', // Implemented
  CLIENT_TAXES_INFO_VIEW = 'CLIENT_TAXES_INFO_VIEW', // Implemented
  CLIENT_TAXES_INFO_EDIT = 'CLIENT_TAXES_INFO_EDIT', // Implemented
  CLIENT_OTHER_INFO_VIEW = 'CLIENT_OTHER_INFO_VIEW', // Implemented
  CLIENT_OTHER_INFO_EDIT = 'CLIENT_OTHER_INFO_EDIT', // Implemented
  CLIENT_WORKING_HOURS_VIEW = 'CLIENT_WORKING_HOURS_VIEW', // Implemented
  CLIENT_WORKING_HOURS_EDIT = 'CLIENT_WORKING_HOURS_EDIT', // Implemented
  CLIENT_KIDZONE_SETTINGS_VIEW = 'CLIENT_KIDZONE_SETTINGS_VIEW', // Implemented
  CLIENT_KIDZONE_SETTINGS_EDIT = 'CLIENT_KIDZONE_SETTINGS_EDIT', // Implemented
  CLIENT_KIDZONE_SETTINGS_CHANGE_STATUS = 'CLIENT_KIDZONE_SETTINGS_CHANGE_STATUS', // Implemented
  CLIENT_INTEGRATION_VIEW = 'CLIENT_INTEGRATION_VIEW', // Implemented
  CLIENT_INTEGRATION_EDIT = 'CLIENT_INTEGRATION_EDIT', // Implemented
  CLIENT_SERVICES_VIEW = 'CLIENT_SERVICES_VIEW', // Implemented TODO: need sync with backend
  CLIENT_SERVICES_EDIT = 'CLIENT_SERVICES_EDIT', // Implemented TODO: need sync with backend
  // corporate management
  CORPORATE_SIGN_IN_AS_SUPPORT_USER = 'CORPORATE_SIGN_IN_AS_SUPPORT_USER', // Implemented
  CORPORATE_TRANSFER_OWNERSHIP = 'CORPORATE_TRANSFER_OWNERSHIP', // Implemented
  CORPORATE_GENERAL_INFO_VIEW = 'CORPORATE_GENERAL_INFO_VIEW', // Implemented
  CORPORATE_GENERAL_INFO_EDIT = 'CORPORATE_GENERAL_INFO_EDIT', // Implemented
  CORPORATE_BANK_INFO_VIEW = 'CORPORATE_BANK_INFO_VIEW', // Implemented
  CORPORATE_BANK_INFO_EDIT = 'CORPORATE_BANK_INFO_EDIT', // Implemented
  CORPORATE_BILLING_INFO_VIEW = 'CORPORATE_BILLING_INFO_VIEW', // Implemented
  CORPORATE_BILLING_INFO_EDIT = 'CORPORATE_BILLING_INFO_EDIT', // Implemented
  CORPORATE_FEE_RATES_VIEW = 'CORPORATE_FEE_RATES_VIEW', // Implemented
  CORPORATE_FEE_RATES_EDIT = 'CORPORATE_FEE_RATES_EDIT', // Implemented
  CORPORATE_PROCESSOR_CONFIGURATION_VIEW = 'CORPORATE_PROCESSOR_CONFIGURATION_VIEW', // Implemented
  CORPORATE_PROCESSOR_CONFIGURATION_EDIT = 'CORPORATE_PROCESSOR_CONFIGURATION_EDIT', // Implemented
  CORPORATE_TAXES_INFO_VIEW = 'CORPORATE_TAXES_INFO_VIEW', // Implemented
  CORPORATE_TAXES_INFO_EDIT = 'CORPORATE_TAXES_INFO_EDIT', // Implemented
  CORPORATE_OTHER_INFO_VIEW = 'CORPORATE_OTHER_INFO_VIEW', // Implemented
  CORPORATE_OTHER_INFO_EDIT = 'CORPORATE_OTHER_INFO_EDIT', // Implemented
  CORPORATE_INTEGRATION_VIEW = 'CORPORATE_INTEGRATION_VIEW', // Implemented
  CORPORATE_INTEGRATION_EDIT = 'CORPORATE_INTEGRATION_EDIT', // Implemented
  CORPORATE_INTEGRATION_CHANGE_STATUS = 'CORPORATE_INTEGRATION_CHANGE_STATUS', // Implemented
  CORPORATE_REQUIRED_FIELDS_VIEW = 'CORPORATE_REQUIRED_FIELDS_VIEW', // Implemented
  CORPORATE_REQUIRED_FIELDS_EDIT = 'CORPORATE_REQUIRED_FIELDS_EDIT', // Implemented
  CORPORATE_PAY_PERIOD_SETTINGS_VIEW = 'CORPORATE_PAY_PERIOD_SETTINGS_VIEW', // Implemented
  CORPORATE_PAY_PERIOD_SETTINGS_CREATE = 'CORPORATE_PAY_PERIOD_SETTINGS_CREATE', // Implemented
  CORPORATE_PAY_PERIOD_SETTINGS_EDIT = 'CORPORATE_PAY_PERIOD_SETTINGS_EDIT', // Implemented
  CORPORATE_PAY_PERIOD_VIEW = 'CORPORATE_PAY_PERIOD_VIEW', // Implemented
  CORPORATE_PAY_PERIOD_EDIT = 'CORPORATE_PAY_PERIOD_EDIT', // Implemented
  CORPORATE_PAY_PERIOD_CHANGE_STATUS = 'CORPORATE_PAY_PERIOD_CHANGE_STATUS', // Implemented
  CORPORATE_SERVICES_VIEW = 'CORPORATE_SERVICES_VIEW', // Implemented TODO: need sync with backend
  CORPORATE_SERVICES_EDIT = 'CORPORATE_SERVICES_EDIT', // Implemented TODO: need sync with backend
  // Communication
  BANNER_ADVERTISEMENT_VIEW = 'BANNER_ADVERTISEMENT_VIEW', // Implemented
  BANNER_ADVERTISEMENT_CREATE = 'BANNER_ADVERTISEMENT_CREATE', // Implemented
  BANNER_ADVERTISEMENT_EDIT = 'BANNER_ADVERTISEMENT_EDIT', // Implemented
  BANNER_ADVERTISEMENT_CHANGE_STATUS = 'BANNER_ADVERTISEMENT_CHANGE_STATUS', // Implemented
  PUSH_NOTIFICATION_VIEW = 'PUSH_NOTIFICATION_VIEW', // Implemented
  PUSH_NOTIFICATION_CREATE = 'PUSH_NOTIFICATION_CREATE', // Implemented
  PUSH_NOTIFICATION_EDIT = 'PUSH_NOTIFICATION_EDIT', // Implemented
  PUSH_NOTIFICATION_CHANGE_STATUS = 'PUSH_NOTIFICATION_CHANGE_STATUS', // Implemented
  // peak level
  PEAK_SU = 'PEAK_SU',
  PEAK_HELP_INFORMATION_VIEW = 'PEAK_HELP_INFORMATION_VIEW', // Implemented
  PEAK_HELP_INFORMATION_CREATE = 'PEAK_HELP_INFORMATION_CREATE', // Implemented
  PEAK_HELP_INFORMATION_EDIT = 'PEAK_HELP_INFORMATION_EDIT', // Implemented
  PEAK_HELP_INFORMATION_CHANGE_STATUS = 'PEAK_HELP_INFORMATION_CHANGE_STATUS', // Implemented
  PEAK_EMPLOYEE_VIEW = 'PEAK_EMPLOYEE_VIEW', // Implemented
  PEAK_EMPLOYEE_CREATE = 'PEAK_EMPLOYEE_CREATE', // Implemented
  PEAK_EMPLOYEE_EDIT = 'PEAK_EMPLOYEE_EDIT', // Implemented
  PEAK_EMPLOYEE_CHANGE_STATUS = 'PEAK_EMPLOYEE_CHANGE_STATUS', // Implemented
  PEAK_ORGANIZATION_VIEW_LIST = 'PEAK_ORGANIZATION_VIEW_LIST', // Implemented
  PEAK_ORGANIZATION_CREATE = 'PEAK_ORGANIZATION_CREATE', // Implemented
  PEAK_ORGANIZATION_CHANGE_STATUS = 'PEAK_ORGANIZATION_CHANGE_STATUS', // Implemented
  PEAK_ORGANIZATION_SIGN_IN_AS_SUPPORT_USER = 'PEAK_ORGANIZATION_SIGN_IN_AS_SUPPORT_USER', // Implemented
  PEAK_ORGANIZATION_TRANSFER_OWNERSHIP = 'PEAK_ORGANIZATION_TRANSFER_OWNERSHIP', // Implemented
  PEAK_ORGANIZATION_GENERAL_INFO_VIEW = 'PEAK_ORGANIZATION_GENERAL_INFO_VIEW', // Implemented
  PEAK_ORGANIZATION_GENERAL_INFO_EDIT = 'PEAK_ORGANIZATION_GENERAL_INFO_EDIT', // Implemented
  PEAK_ORGANIZATION_BANK_INFO_VIEW = 'PEAK_ORGANIZATION_BANK_INFO_VIEW', // Implemented
  PEAK_ORGANIZATION_BANK_INFO_EDIT = 'PEAK_ORGANIZATION_BANK_INFO_EDIT', // Implemented
  PEAK_ORGANIZATION_BILLING_INFO_VIEW = 'PEAK_ORGANIZATION_BILLING_INFO_VIEW', // Implemented
  PEAK_ORGANIZATION_BILLING_INFO_EDIT = 'PEAK_ORGANIZATION_BILLING_INFO_EDIT', // Implemented
  PEAK_ORGANIZATION_FEE_RATES_VIEW = 'PEAK_ORGANIZATION_FEE_RATES_VIEW', // Implemented
  PEAK_ORGANIZATION_FEE_RATES_EDIT = 'PEAK_ORGANIZATION_FEE_RATES_EDIT', // Implemented
  PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_VIEW = 'PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_VIEW', // Implemented
  PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_EDIT = 'PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_EDIT', // Implemented
  PEAK_ORGANIZATION_TAXES_INFO_VIEW = 'PEAK_ORGANIZATION_TAXES_INFO_VIEW', // Implemented
  PEAK_ORGANIZATION_TAXES_INFO_EDIT = 'PEAK_ORGANIZATION_TAXES_INFO_EDIT', // Implemented
  PEAK_ORGANIZATION_INTEGRATION_VIEW = 'PEAK_ORGANIZATION_INTEGRATION_VIEW', // Implemented
  PEAK_ORGANIZATION_INTEGRATION_EDIT = 'PEAK_ORGANIZATION_INTEGRATION_EDIT', // Implemented
  PEAK_ORGANIZATION_INTEGRATION_CHANGE_STATUS = 'PEAK_ORGANIZATION_INTEGRATION_CHANGE_STATUS', // Implemented
  PEAK_ORGANIZATION_OTHER_VIEW = 'PEAK_ORGANIZATION_OTHER_VIEW', // Implemented
  PEAK_ORGANIZATION_OTHER_EDIT = 'PEAK_ORGANIZATION_OTHER_EDIT', // Implemented
  PEAK_ORGANIZATION_REQUIRED_FIELDS_VIEW = 'PEAK_ORGANIZATION_REQUIRED_FIELDS_VIEW', // Implemented
  PEAK_ORGANIZATION_REQUIRED_FIELDS_EDIT = 'PEAK_ORGANIZATION_REQUIRED_FIELDS_EDIT', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_VIEW = 'PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_VIEW', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_CREATE = 'PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_CREATE', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_EDIT = 'PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_EDIT', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_VIEW = 'PEAK_ORGANIZATION_PAY_PERIOD_VIEW', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_EDIT = 'PEAK_ORGANIZATION_PAY_PERIOD_EDIT', // Implemented
  PEAK_ORGANIZATION_PAY_PERIOD_CHANGE_STATUS = 'PEAK_ORGANIZATION_PAY_PERIOD_CHANGE_STATUS', // Implemented
  PEAK_ORGANIZATION_SERVICES_VIEW = 'PEAK_ORGANIZATION_SERVICES_VIEW', // Implemented TODO: need sync with backend
  PEAK_ORGANIZATION_SERVICES_EDIT = 'PEAK_ORGANIZATION_SERVICES_EDIT', // Implemented TODO: need sync with backend
  PEAK_SETTINGS_INTEGRATION_VIEW = 'PEAK_INTEGRATION_VIEW', // Implemented
  PEAK_SETTINGS_INTEGRATION_EDIT = 'PEAK_INTEGRATION_EDIT', // Implemented
  PEAK_SETTINGS_INTEGRATION_CHANGE_STATUS = 'PEAK_INTEGRATION_CHANGE_STATUS', // Implemented
  PEAK_SETTINGS_GENERAL_VIEW = 'PEAK_SETTINGS_GENERAL_VIEW', // Implemented
  PEAK_SETTINGS_GENERAL_EDIT = 'PEAK_SETTINGS_GENERAL_EDIT', // Implemented
  PEAK_SETTINGS_FEE_RATES_VIEW = 'PEAK_SETTINGS_FEE_RATES_VIEW', // Implemented
  PEAK_SETTINGS_FEE_RATES_EDIT = 'PEAK_SETTINGS_FEE_RATES_EDIT', // Implemented
  PEAK_SECURITY_ROLE_VIEW = 'PEAK_SECURITY_ROLE_VIEW', // Implemented
  PEAK_SECURITY_ROLE_CREATE = 'PEAK_SECURITY_ROLE_CREATE', // Implemented
  PEAK_SECURITY_ROLE_EDIT = 'PEAK_SECURITY_ROLE_EDIT', // Implemented
  PEAK_SECURITY_ROLE_CHANGE_STATUS = 'PEAK_SECURITY_ROLE_CHANGE_STATUS', // Implemented
  PEAK_SECURITY_POLICY_VIEW = 'PEAK_SECURITY_POLICY_VIEW', // Implemented
  PEAK_SECURITY_POLICY_CREATE = 'PEAK_SECURITY_POLICY_CREATE', // Implemented
  PEAK_SECURITY_POLICY_EDIT = 'PEAK_SECURITY_POLICY_EDIT', // Implemented
  PEAK_SECURITY_POLICY_CHANGE_STATUS = 'PEAK_SECURITY_POLICY_CHANGE_STATUS', // Implemented
  PEAK_REMITTANCE_VIEW = 'PEAK_REMITTANCE_VIEW', // Implemented TODO: need sync with backend
  PEAK_REMITTANCE_CALCULATE = 'PEAK_REMITTANCE_CALCULATE', // Implemented TODO: need sync with backend
  PEAK_REMITTANCE_CANCEL = 'PEAK_REMITTANCE_CANCEL', // Implemented TODO: need sync with backend
  PEAK_REMITTANCE_DOWNLOAD = 'PEAK_REMITTANCE_DOWNLOAD', // Implemented TODO: need sync with backend
  PEAK_REMITTANCE_SEND = 'PEAK_REMITTANCE_SEND', // Implemented TODO: need sync with backend
  PEAK_REMITTANCE_FINALIZE = 'PEAK_REMITTANCE_FINALIZE', // Implemented TODO: need sync with backend
  // client adjustments
  PEAK_CLIENT_ADJUSTMENTS_VIEW = 'PEAK_CLIENT_ADJUSTMENTS_VIEW', // Implemented
  PEAK_CLIENT_ADJUSTMENTS_CREATE = 'PEAK_CLIENT_ADJUSTMENTS_CREATE', // Implemented
  PEAK_CLIENT_ADJUSTMENTS_EDIT = 'PEAK_CLIENT_ADJUSTMENTS_EDIT', // Implemented
  PEAK_CLIENT_ADJUSTMENTS_CHANGE_STATUS = 'PEAK_CLIENT_ADJUSTMENTS_CHANGE_STATUS', // Implemented
  PEAK_CLIENT_ADJUSTMENTS_EXPORT = 'PEAK_CLIENT_ADJUSTMENTS_EXPORT', // Implemented
  PEAK_RECURRING_CLIENT_ADJUSTMENTS_VIEW = 'PEAK_RECURRING_CLIENT_ADJUSTMENTS_VIEW', // Implemented
  PEAK_RECURRING_CLIENT_ADJUSTMENTS_CREATE = 'PEAK_RECURRING_CLIENT_ADJUSTMENTS_CREATE', // Implemented
  PEAK_RECURRING_CLIENT_ADJUSTMENTS_EDIT = 'PEAK_RECURRING_CLIENT_ADJUSTMENTS_EDIT', // Implemented
  PEAK_RECURRING_CLIENT_ADJUSTMENTS_CHANGE_STATUS = 'PEAK_RECURRING_CLIENT_ADJUSTMENTS_CHANGE_STATUS', // Implemented
  PEAK_RECURRING_CLIENT_ADJUSTMENTS_EXPORT = 'PEAK_RECURRING_CLIENT_ADJUSTMENTS_EXPORT', // Implemented
  PEAK_ADJUSTMENT_CATEGORY_VIEW = 'PEAK_ADJUSTMENT_CATEGORY_VIEW', // Implemented
  PEAK_ADJUSTMENT_CATEGORY_CREATE = 'PEAK_ADJUSTMENT_CATEGORY_CREATE', // Implemented
  PEAK_ADJUSTMENT_CATEGORY_EDIT = 'PEAK_ADJUSTMENT_CATEGORY_EDIT', // Implemented
}

export enum PermissionGroup {
  FINANCIAL = 'FINANCIAL',
  POINT_OF_SALE_POS = 'POINT_OF_SALE_POS',
  COLLECTIONS = 'COLLECTIONS',
  CORPORATE_LEVEL = 'CORPORATE_LEVEL',
  SERVICE_MANAGEMENT = 'SERVICE_MANAGEMENT',
  DICTIONARIES = 'DICTIONARIES',
  PERMISSIONS = 'PERMISSIONS',
  CORPORATE_MANAGEMENT = 'CORPORATE_MANAGEMENT',
  COMMUNICATION = 'COMMUNICATION',
  SCHEDULING = 'SCHEDULING',
  CRM = 'CRM',
  PT_CRM = 'PT_CRM',
  POS_CONTENT = 'POS_CONTENT',
  MEMBER_MANAGEMENT = 'MEMBER_MANAGEMENT',
  EMPLOYEE_MANAGEMENT = 'EMPLOYEE_MANAGEMENT',
  TIME_CLOCK = 'TIME_CLOCK',
  REPORTING = 'REPORTING',
  SALES_MANAGEMENT = 'SALES_MANAGEMENT',
  CLIENT_MANAGEMENT = 'CLIENT_MANAGEMENT',
  PEAK_LEVEL = 'PEAK_LEVEL',
}

export enum PermissionLevels {
  CLIENT = 'CLIENT',
  CORPORATE = 'CORPORATE',
  PEAK = 'PEAK',
}

export enum AppPermissionLevel {
  Club = 'CLUB',
  Corporate = 'CORPORATE',
  ClubCorporate = 'CLUB_CORPORATE',
  Peak = 'PEAK',
}

// TODO - 3581 remove
export const PermissionsLevelsLabels = {
  [PermissionLevels.CLIENT]: <FormattedMessage {...commonMessages.clubTitle} />,
  [PermissionLevels.CORPORATE]: <FormattedMessage {...commonMessages.corporateTitle} />,
  [PermissionLevels.PEAK]: <FormattedMessage {...commonMessages.peakTitle} />,
};
